import React, {
  useState,
  useEffect,

} from "react";

import getDay from "../function/getDay.js";
import getUrl from "../function/getUrl.js";
import checkLogin from "../function/checkLogin.js";
import birthdayToAge from "../function/birthdayToAge.js";

// 將日期轉換為星期的函數
const getWeekday = (dateString) => {
  if (!dateString) return '';
  
  const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
  const date = new Date(dateString);
  
  if (isNaN(date.getTime())) return dateString; // 如果無法解析日期，返回原始字符串
  
  const weekday = weekdays[date.getDay()];
  const formattedDate = dateString.split('-').join('/'); // 將格式從 YYYY-MM-DD 改為 YYYY/MM/DD
  
  return `(${weekday})`;
};

//14天內未體驗完課學員
const DashBoard14Days = (props) => {
  const url = getUrl();
  const token = sessionStorage.getItem("token");
  const [trialList, setTrialList] = useState([]);
  let today = getDay(0, "-");
  if (!checkLogin()) {
    window.location.href = "/logout";
  }

  useEffect(async () => {
   const reulst= await fetch(`${url}/appGet/DashBoard14Days?token=${token}`)
      .then((res) => res.json())
    setTrialList(reulst)
  },[])
 
  return (
    <>
      <div className="card" style={{ width: "18rem;" }}>
        <div className="card-header">14天內未體驗完課學員</div>
        <div className="card-body alert-info">
          <div className="row">
                    <table class="table table-striped">
          <thead>
            <tr className="text-center">
              <th scope="col">編號</th>
              <th scope="col">姓名/暱稱</th>
              <th scope="col">年紀</th>
              <th scope="col">日期</th>
              <th scope="col">時間</th>
              <th scope="col">班別</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {trialList.map((item, index) => {
            return (
            <tr key={index}>
              <td  className="text-center">{index+1}</td>
              <td className="text-center">{item.name}</td>
              <td className="text-center">{birthdayToAge(item.birthday)[0]}</td>
              <td className="text-center">{item.classDate} {getWeekday(item.classDate)}</td>
               <td className="text-center">{item.classTime}</td>
                <td className="text-center">{item.age}</td>
            </tr>)
})}

            
          </tbody>
        </table>

          </div>
        </div>
      </div>

    </>
  );
};

export default DashBoard14Days;
